module.exports = __webpack_public_path__ + "static/event8-2cfcd927e1209be804ace54b27d80dd0.jpg";